import { SettingsManager } from "@viamap/viamap2-common";
import { BNBOErstatningLinie, BNBOErstatningLinieNoTotal, BNBODel, BNBOOmrådeType, BNBOState, safeGetDoubleDepthObject } from "../BNBOModule/BNBOState";
import { constructMaskObj, getAllDeleForLodsejer, getAllSubFeaturesLodsejer, getSFEAsFeatureList, nonOverlappingGeoAdv } from "./BNBOAreaEditorExtra";

export const BNBOBeregninger = {
   sumErstatninger,
   udregnErstatningEjendom,
   udregnErstatningMark,
   udregnErstatningEnkel,
   udregnMarkArealByType,
   getKommuneErstatningsProcent,
   getDefaultSats,
   faktorByMarkDelType,
   faktorByOmrådeType,
   faktorFormat,
   formatErstatningsBeregningMark,
   formatErstatningsBeregningEjendom,
   formatTotalErstatning,
};

function roundAndCalculateTotal(record: BNBOErstatningLinieNoTotal): BNBOErstatningLinie {
   let afrundetAntal = Math.round(record.antal);


   return {
      ...record,
      antal: afrundetAntal,
      erstatning: afrundetAntal * record.takst * record.faktor * record.procent
   };
}

function udregnErstatningEjendom(bnboState: BNBOState, lodsejerId: string): BNBOErstatningLinie[] {
   let lodsejer = bnboState.lodsejer[lodsejerId];
   // return new Promise<{ res: any[], erst: BNBOErstatningLinie[] }> ((resolve, reject) => { 
   let erst: BNBOErstatningLinie[] = [];

   let dele = getAllDeleForLodsejer(bnboState, lodsejerId).filter((a) => !(a.properties.type === BNBOOmrådeType.Inaktive))
   let geo = nonOverlappingGeoAdv(dele, true, getSFEAsFeatureList(bnboState, lodsejerId), constructMaskObj(getAllSubFeaturesLodsejer(bnboState, lodsejerId)));
   for (let feat of geo) {
      // console.log("feat props", feat.properties);
      let takst = 0
      if (feat.properties.isManualTakst) {
         takst = (feat.properties.takst ?? SettingsManager.getSystemSetting("bnbo.defaultManualTakst"));
      } else {
         takst = lodsejer.sats || getDefaultSats();
      }

      erst.push(roundAndCalculateTotal({
         geometry: feat.geometry,
         areaType: feat.properties.type,
         antal: feat.properties.arealNetto,
         takst: takst,
         faktor: ((feat.properties.isManualTakst && 1) || feat.properties.faktor) ?? faktorByOmrådeType(feat.properties.type),
         procent: (feat.properties.isManualTakst && 1) || getKommuneErstatningsProcent(),
         isManualTakst: feat.properties.isManualTakst || false,
         note: feat.properties.note,
         mask: feat.properties.mask,
         farve: feat.properties.farve,
         matrikel: feat.properties.mask ? { ejerlavsKode: feat.properties.mask, ejerlavsNavn: "", matrikelNummer: feat.properties.mask } : undefined
         // mark: mark ? { markBlok: mark.markBlok, markNr: mark.markNr, afgrøde: mark.afgrøde } : undefined
      }));
   }
   return erst;
}

function sumErstatninger(erstatningsListe: { erstatning: number }[]) {
   return erstatningsListe.reduce((pre, cur) => pre + cur.erstatning, 0)
}

function udregnErstatningMark(state: BNBOState, lodsejerId, markId) {
   let markDele: BNBODel[] = safeGetDoubleDepthObject(state.markDele, lodsejerId, markId) || [];

   let delTyper: BNBOOmrådeType[] = [...new Set(markDele.map((a) => a.type))]

   return delTyper.map((a) => {
      let res = {
         type: a,
         antal: udregnMarkArealByType(state, lodsejerId, markId, a),
         takst: getDefaultSats(),
         faktor: faktorByMarkDelType(a),
         procent: getKommuneErstatningsProcent(),
      }
      return {
         ...res,
         erstatning: udregnErstatningEnkel(res)
      }
   })
}

function udregnErstatningEnkel(markDel: { antal: number, takst: number, faktor: number, procent: number }) {
   return markDel.antal * markDel.takst * markDel.faktor * markDel.procent
}

function udregnMarkArealByType(state: BNBOState, lodsejerId, markId, markType: BNBOOmrådeType): number {
   return state.markDele[lodsejerId][markId].reduce((pre, cur) => cur.type == markType ? cur.arealNetto + pre : pre, 0)
}


function getKommuneErstatningsProcent() {
   return SettingsManager.getSystemSetting("bnbo.kommuneErstatningsProcent") / 100
}

function getDefaultSats() {
   return SettingsManager.getSystemSetting("bnbo.landbrugsArealPris.min") || 123
}

function faktorByMarkDelType(markType: BNBOOmrådeType) {
   switch (markType) {
      // ToDo: get from settings!!!!
      case BNBOOmrådeType.ServitutAreal: return SettingsManager.getSystemSetting("bnbo.erstatningsFaktorer.omdriftsAreal")
      case BNBOOmrådeType.FradragsAreal: return SettingsManager.getSystemSetting("bnbo.erstatningsFaktorer.andetAreal")
      case BNBOOmrådeType.UlempeAreal: return SettingsManager.getSystemSetting("bnbo.erstatningsFaktorer.andetAreal")
      case BNBOOmrådeType.Restareal: return SettingsManager.getSystemSetting("bnbo.erstatningsFaktorer.paragraf3Areal")

      default:
         throw new Error("Unexpected markDelType: " + markType)

   }
}

function faktorByOmrådeType(markType: BNBOOmrådeType) {
   switch (markType) {
      case BNBOOmrådeType.ServitutAreal: return SettingsManager.getSystemSetting("bnbo.erstatningsFaktorer.omdriftsAreal")
      case BNBOOmrådeType.FradragsAreal: return SettingsManager.getSystemSetting("bnbo.erstatningsFaktorer.fradragsAreal")
      case BNBOOmrådeType.UlempeAreal: return SettingsManager.getSystemSetting("bnbo.erstatningsFaktorer.ulempeAreal")
      case BNBOOmrådeType.Restareal: return SettingsManager.getSystemSetting("bnbo.erstatningsFaktorer.servitutAreal")
      case BNBOOmrådeType.FredskovsAreal: return SettingsManager.getSystemSetting("bnbo.erstatningsFaktorer.fredskovsAreal")
      case BNBOOmrådeType.Par3Areal: return SettingsManager.getSystemSetting("bnbo.erstatningsFaktorer.paragraf3Areal")
      case BNBOOmrådeType.Vejareal: return SettingsManager.getSystemSetting("bnbo.erstatningsFaktorer.vejareal")
      case BNBOOmrådeType.MarkServitutareal: return SettingsManager.getSystemSetting("bnbo.erstatningsFaktorer.omdriftsAreal")
      default:
         return SettingsManager.getSystemSetting("bnbo.erstatningsFaktorer.omdriftsAreal")
      // throw new Error("Unexpected delType: " + markType)
   }
}

function faktorFormat(markType: BNBOOmrådeType) {
   switch (markType) {
      case BNBOOmrådeType.Vejareal: return "Vejareal"
      case BNBOOmrådeType.ServitutAreal: return "Omdriftsareal"
      case BNBOOmrådeType.FradragsAreal: return "Fradrag"
      case BNBOOmrådeType.UlempeAreal: return "Ulempe"
      case BNBOOmrådeType.Restareal: return "Restservitutareal"
      case BNBOOmrådeType.FredskovsAreal: return "Fredskov"
      case BNBOOmrådeType.MarkServitutareal: return "Markservitut"
      case BNBOOmrådeType.Par3Areal: return "Paragraf 3"
      default:
         return "Undefined";
      // throw new Error("Unexpected markType: " + markType)
   }
}

function formatErstatningsBeregningMark(input: any[]) {
   const pris = Intl.NumberFormat("da-dk", {
      style: "currency",
      currency: "dkk"
   })
   const areal = Intl.NumberFormat("da-dk", {
      maximumFractionDigits: 0,
   })
   const fraction = Intl.NumberFormat("da-dk")

   return input.map((a) => ({
      type: a.type,
      erstatning_formatted: pris.format(a.erstatning),
      type_formatted: faktorFormat(a.type),
      antal_formatted: areal.format(a.antal) + " m²",
      takst_formatted: pris.format(a.takst),
      faktor_formatted: fraction.format(a.faktor),
      procent_formatted: (a.procent * 100).toFixed(0) + "%",
      note: a.note || ""
   }))
}

function formatErstatningsBeregningEjendom(input: BNBOErstatningLinie[]): any[] {
   const pris = Intl.NumberFormat("da-dk", {
      style: "currency",
      currency: "dkk"
   })
   const areal = Intl.NumberFormat("da-dk", {
      maximumFractionDigits: 0,
   })
   const fraction = Intl.NumberFormat("da-dk", { minimumFractionDigits: 1, maximumFractionDigits: 1 })

   return input.map((a) => ({
      ...a,
      type: a.areaType,
      erstatning_formatted: pris.format(a.erstatning),
      type_formatted: faktorFormat(a.areaType),
      antal_formatted: areal.format(a.antal) + " m²",
      takst_formatted: pris.format(a.takst),
      faktor_formatted: a.isManualTakst ? "-" : fraction.format(a.faktor),
      procent_formatted: a.isManualTakst ? "-" : (a.procent * 100).toFixed(0) + "%",
      note: a.note || ""
   }))
}

function formatTotalErstatning(erstatning?: number) {
   return (erstatning || 0).toLocaleString("da-dk", {
      style: "currency",
      currency: "dkk"
   })
}

